angular.module('impactx.legallinking').controller('LegalLinkingCtrl', [
    '$scope',
    '$sce',
    '$mdDialog',
    'NewWindowService',
    'locals',
    LegalLinkingCtrl]);

function LegalLinkingCtrl($scope, $sce, $mdDialog, NewWindowService, locals) {
    $scope.link = $sce.trustAsResourceUrl(locals.link);
    $scope.title = locals.title;

    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.openInNewTab = function () {
        var tab = NewWindowService.openNewWindow($scope.link, '_blank');
        if (tab) {
            tab.focus();
        }
    };
}